import { render } from "./KnImageToBase64IconPicker.vue?vue&type=template&id=74bd676b"
import script from "./KnImageToBase64IconPicker.vue?vue&type=script&lang=js"
export * from "./KnImageToBase64IconPicker.vue?vue&type=script&lang=js"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__